<div class="profile-selection">
  <div class="selection-header">
    <h3>Choisissez vos formules</h3>
    <p>Sélectionnez une formule pour les membres de votre famille qui souhaitent participer</p>
  </div>

  <div class="profiles-selection">
    <div *ngIf="!profiles || profiles.length === 0" class="empty-state">
      <mat-icon>person_off</mat-icon>
      <p>Aucun profil sélectionné</p>
      <p>Veuillez d'abord sélectionner des profils</p>
    </div>
    
    <form [formGroup]="form" *ngIf="profiles && profiles.length > 0">
      <div *ngFor="let profile of profiles; let i = index" 
           class="profile-row">
        
        <div class="profile-info">
          <span class="profile-name">{{profile.fullName}}</span>
        </div>

        <div class="profile-options">
          <!-- Affichage si le profil a déjà souscrit -->
          <div *ngIf="hasProfileAlreadySubscribed(profile.id)" class="already-subscribed">
            <div class="subscription-info">
              <mat-icon>check_circle</mat-icon>
              <span class="subscription-text">Déjà souscrit à :</span>
            </div>
            <div *ngFor="let existingChoice of getExistingChoicesForProfile(profile.id)" class="existing-choice">
              <span class="choice-name">{{existingChoice.choiceName}}</span>
              <span class="choice-price">{{existingChoice.totalPrice}}€</span>
            </div>
          </div>

          <!-- Affichage normal si pas de souscription existante -->
          <div *ngIf="!hasProfileAlreadySubscribed(profile.id)" class="options-toggle-group">
            <button
              type="button"
              (click)="onOptionChange(i, null)"
              class="option-toggle no-selection"
              [class.selected]="form.get('profile_' + i)?.value === null">
              <div class="toggle-content">
                <span class="option-name">Aucune sélection</span>
                <span class="option-description">Ce membre ne participe pas</span>
              </div>
            </button>
            <button
              *ngFor="let option of getAvailableOptions(profile)"
              type="button"
              (click)="onOptionChange(i, option.id)"
              [disabled]="!option.is_available"
              class="option-toggle"
              [class.selected]="form.get('profile_' + i)?.value === option.id"
              [class.unavailable]="!option.is_available">
              <div class="toggle-content">
                <span class="option-name">{{option.name}}</span>
                <span class="option-price">{{option.price | currency:'EUR':'symbol':'1.2-2'}}</span>
                <div *ngIf="option.description" class="option-description">
                  {{option.description}}
                </div>
                <div *ngIf="getStockInfo(option).remaining !== null" class="quantity-info">
                  <span *ngIf="option.is_available" class="quantity-available">
                    {{getStockInfo(option).remaining}} restant{{(getStockInfo(option).remaining || 0) > 1 ? 's' : ''}}
                    <span *ngIf="getStockInfo(option).isShared" class="stock-group-name">
                      ({{getStockInfo(option).name}})
                    </span>
                  </span>
                  <span *ngIf="!option.is_available" class="quantity-unavailable">
                    Épuisé
                    <span *ngIf="getStockInfo(option).isShared" class="stock-group-name">
                      ({{getStockInfo(option).name}})
                    </span>
                  </span>
                </div>
              </div>
            </button>
          </div>

          <div *ngIf="addsPhraseToExistingBrick(profile)" class="wall-message-notice">
            <mat-checkbox [checked]="true" [disabled]="true" color="primary">
              Vous avez déjà une brique sur le mur des Socios : vous pourrez ajouter votre message personnalisé
            </mat-checkbox>
          </div>
        </div>

          <div *ngIf="hasProfileError(profile.id)" class="profile-error">
            <mat-icon>error</mat-icon>
            <span>{{getProfileError(profile.id)}}</span>
          </div>
        </div>
    </form>
    
    <div *ngIf="errors['general']" class="general-error">
      <mat-icon>error</mat-icon>
      <span>{{errors['general']}}</span>
    </div>
  </div>
</div> 